module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/shoes/icon_87ce946547e7e239c9ad421f256fedd0.png";